import { TeamUser } from '@/api';

/** Whether the user administers the team, whether directly or by inheritance. */
export function isTeamAdmin(team: TeamUser): boolean {
    return team.roles.some((role) => role.name === 'admin');
}

/** Whether the user is a guardian of the team, directly or by inheritance. */
export function isTeamGuardian(team: TeamUser): boolean {
    return team.roles.some((role) => role.name === 'guardian');
}

/** Whether the user holds any role within the team beyond plain membership. */
export function isTeamAdminOrGuardian(team: TeamUser): boolean {
    return isTeamAdmin(team) || isTeamGuardian(team);
}
